import {useTranslation} from "@i18n";

import stl from "./AdNumber.module.css";

const AdNumber = (props) => {
  const { t } = useTranslation(["web_post_view"]);

  return (
    <>
      <div className={stl.container}>
        <div>
          <span>
            
            {t("رقم الأعلان:", {
              ns: "web_post_view",
            })}
            
          </span>
          <strong>{props.adNumber}</strong>
        </div>
        {!props.isTrackingView && (
          <p>
            {t("أذكر رقم الأعلان عند الاتصال مع خدمة العملاء", {
              ns: "web_post_view",
            })}
          </p>
        )}
      </div>
    </>
  );
};

export default AdNumber;
